module.exports = __webpack_public_path__ + "resources/icon_28_right.b268d007ec6b11a0.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_right.png
// module id = 428
// module chunks = 0 1 2 3 4